import { FC, useCallback, useMemo } from "react";
import { capitalize } from "@mui/material";
import { WidgetNormalizedCostVisualization } from "@/services/cloudchipr.api";
import { SwitchWithTypography } from "@/components/SwitchWithTypography";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetSetupVisualizationSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/visualization/normalizedCostWidgetSetupVisualizationSelector";
import { normalizedCostWidgetVisualizationChangeThunk } from "@/store/dashboards/thunks/widgets/normalized-cost-widget/setup-change/normalizedCostWidgetVisualizationChangeThunk";

interface NormalizedCostWidgetVisualizationSwitchProps {
  visualizationKey: keyof WidgetNormalizedCostVisualization;
}

export const NormalizedCostWidgetVisualizationSwitch: FC<
  NormalizedCostWidgetVisualizationSwitchProps
> = ({ visualizationKey }) => {
  const dispatch = useAppDispatch();
  const title = useMemo(
    () =>
      visualizationKey
        .split("_")
        .map((word) => capitalize(word))
        .join(" "),
    [visualizationKey],
  );
  const checked = !!useAppSelector(
    normalizedCostWidgetSetupVisualizationSelector,
  )?.[visualizationKey];

  const handleChange = useCallback(
    (newChecked: boolean) => {
      dispatch(
        normalizedCostWidgetVisualizationChangeThunk({
          [visualizationKey]: newChecked,
        }),
      );
    },
    [dispatch, visualizationKey],
  );

  return (
    <SwitchWithTypography
      title={title}
      checked={checked}
      onChange={handleChange}
    />
  );
};
